import { ProfileService } from '@/pages/profile/profile.service';
import { CommitteeService } from '@/pages/settings/committee/committee.service';
import { MeetingRepository } from '@/store/meeting-state/meeting-state.repository';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { MeetingService } from '../meeting.service';
import { MEETING_STATUS, Participant } from '@/types/meeting.types';
import { getInspectMeetingFormObject } from './utils/inspect-meeting-form-object';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { StatusComponent } from '@/components/shared/status/status.component';
import { MeetingTransformationService } from '../meeting-transformation.service';

@Component({
  selector: 'sm-inspect-meeting',
  imports: [PageHeaderComponent, FormBuilderComponent, StatusComponent],
  templateUrl: './inspect-meeting.component.html',
  styleUrl: './inspect-meeting.component.scss',
})
export class InspectMeetingComponent implements OnInit {
  meetingService = inject(MeetingService);
  meetingTransformationService = inject(MeetingTransformationService);
  meetingRepository = inject(MeetingRepository);
  comitteeService = inject(CommitteeService);
  translate = inject(TranslateService);
  router = inject(Router);
  profileService = inject(ProfileService);
  messageService = inject(MessageService);
  activatedRoute = inject(ActivatedRoute);

  breadcrumb = [
    {
      label: 'meeting.breadcrumb.meeting',
      routerLink: ['/meetings'],
    },
    {
      label: 'meeting.breadcrumb.inspect',
      routerLink: ['/meetings', 'inspect'],
    },
  ];

  id = this.activatedRoute.snapshot.params['id'];

  comMembers: Participant[] = [];

  plannedDossiers: any[] = [];

  status: MEETING_STATUS = MEETING_STATUS.BROUILLON;

  formObject: DynamicForm = getInspectMeetingFormObject({
    store: this.meetingRepository,
    status: this.status,
    comMembers: this.comMembers,
    plannedDossiers: this.plannedDossiers,
    comOptions: [],
  });

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.meetingService.getOne(this.id).subscribe({
      next: response => {
        this.status = response.status;
        this.meetingTransformationService.setResponseToDtoOnLoadData(response);
        this.meetingRepository.set('comSelected', response.com ? { name: response.com.nom, code: response.com.id } : undefined);
        this.comMembers = response.participants;
        this.plannedDossiers = this.meetingTransformationService.mergePlannedDossiers();
        this.formObject = getInspectMeetingFormObject({
          store: this.meetingRepository,
          status: this.status,
          comMembers: this.comMembers,
          plannedDossiers: this.plannedDossiers,
          comOptions: [{ name: response.com.nom, code: response.com.id }],
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: this.translate.instant('meeting.message.error.loading'),
        });
      },
    });
  }
}
